module.exports = __webpack_public_path__ + "img/介绍Mobile.6760c6cd.png";